export default __webpack_public_path__ + "static/media/header-img.f275ce58.png";